<div class="object-viewer-container">
  <mat-slide-toggle class="customToggle" [checked]="enableObjectEnable" (change)="toggleChange($event)">
    {{(enableObjectEnable) ? 'Enable' : 'Disable'}}
  </mat-slide-toggle>
</div>

<div *ngIf="enableObjectEnable" class="full-width form-object-viewer">
  <p-tree [value]="formTree"></p-tree>

</div>